import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function FlashOn({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.9999 2.66668C6.84526 2.66668 2.66659 6.84535 2.66659 12C2.66659 17.1547 6.84526 21.3333 11.9999 21.3333C14.5437 21.3333 16.8497 20.3157 18.5332 18.6654C20.2612 16.9714 21.3333 14.6109 21.3333 12C21.3333 6.84535 17.1546 2.66668 11.9999 2.66668ZM22.6666 12C22.6666 17.891 17.891 22.6667 11.9999 22.6667C6.10888 22.6667 1.33325 17.891 1.33325 12C1.33325 9.09285 2.49627 6.45732 4.38242 4.53332L4.38241 4.53331C4.46818 4.44583 4.55544 4.35981 4.64417 4.2753C6.55429 2.45586 9.13839 1.33761 11.9836 1.33336C11.9891 1.33335 11.9945 1.33334 11.9999 1.33334C17.891 1.33334 22.6666 6.10897 22.6666 12ZM6.66659 13.3333L14.6666 4.66668L12.6666 10H17.3333L9.33325 18.6667L11.3333 13.3333H6.66659Z"
        fill={iconColor}
      />
    </Svg>
  );
}
